export type ScheduleCalendarType = "Day" | "Week" | "Fortnight" | "Month";
export const ScheduleCalendarTypes = {
    Day: "Day" as ScheduleCalendarType,
    Week: "Week" as ScheduleCalendarType,
    Fortnight: "Fortnight" as ScheduleCalendarType,
    Month: "Month" as ScheduleCalendarType
};